import { withTranslation } from 'react-i18next';
import MonthYearView from './MonthYearView.component';
import I18N_DOMAIN_COMPONENTS from '../../../constants';

export default withTranslation(I18N_DOMAIN_COMPONENTS)(MonthYearView);
